import { SectionsInput, SectionsOutput } from "@/interfaces/sections";
import { BaseService, QueryParams } from "./BaseService";

export class SectionsService extends BaseService<
  SectionsInput,
  SectionsOutput
> {
  constructor() {
    super();
    this.path = "sections";
  }

  async findByMenuId(
    menuId: string,
    params?: QueryParams
  ): Promise<SectionsOutput[]> {
    const url = `menus/${menuId}/${this.path}`;
    const response = await this.request<SectionsOutput[]>(url, {
      queryParams: params,
      method: "GET",
    });

    return response;
  }
}
